module.exports = __webpack_public_path__ + "img/us-3.9e76a6dc.png";